  $(document).on('submit', '.cart-add-shortcut', function (e) {
      e.preventDefault();
      $.ajax({
          url: $(this).attr('action'),
          data: $(this).serialize(),
          method: $(this).attr('method')
      });
	})

 // Chargement de la main modal a partir d'un lien
$(document).on('click', 'a[data-toggle="main-modal"]', function (e) {
  e.preventDefault();
  var modal = $('#main-modal');
  modal.find('.spinner').show();
  modal.modal('show');
	modal.find('.modal-body').css('opacity', '0.5');
  $.ajax({
      url: $(this).attr('href'),
      complete: function(html) {
          modal.find('.spinner').hide();
          modal.find('.modal-body').css('opacity', '1');
					modal.find('.modal-content').html(html.responseText);
      }
  });
});

 // Chargement de la main modal a partir d'un formulaire
$(document).on('click', 'button[data-toggle="main-modal"]', function (e) {

  e.preventDefault();
  var modal = $('#main-modal');
  modal.find('.modal-body').css('opacity', '0.5');
  modal.find('.spinner').show();
  var form = $(this).parents('form');
  modal.modal('show');

  $.ajax({
      data: form.serialize(),
      type: form.attr('method'),
      url: form.attr('action'),
      complete: function(response) {
        modal.find('.spinner').hide();
        modal.find('.modal-body').css('opacity', '1');
        var ct = response.getResponseHeader("content-type") || "";
        if (ct.indexOf('html') > -1) {
            modal.find('.modal-content').html(response.responseText);
        }
        if (ct.indexOf('json') > -1) {
            var json = $.parseJSON(response.responseText);
            if (json.redirectTo !== undefined) {
                window.location.href = json.redirectTo;
            }
        }
      }
  });
});

// Submit d'un formulaire dans la main modal
$('#main-modal').on('click', 'button[type="submit"]', function(e) {
  e.preventDefault();
  var modal = $('#main-modal');
  modal.find('.spinner').show();
  modal.find('.modal-body').css('opacity', '0.5');
  var form = $(this).parents('form');
  $.ajax({
      url: form.attr('action'),
      data: form.serialize(),
      type: form.attr('method'),
      complete: function(response) {
          modal.find('.spinner').hide();
          modal.find('.modal-body').css('opacity', '1');

          var ct = response.getResponseHeader("content-type") || "";
          if (ct.indexOf('html') > -1) {
              modal.find('.modal-content').html(response.responseText);
          }
          if (ct.indexOf('json') > -1) {
              var json = $.parseJSON(response.responseText);
              if (json.redirectTo !== undefined) {
                  window.location.href = json.redirectTo;
              }
          }
      }
  })
});

// Submit d'un formulaire dans la main modal
$('body').on('click', 'form.cart-add button[type="submit"]', function(e) {
  e.preventDefault();
  var form = $(this).parents('form');
  var modal = $('#main-modal');
  modal.modal('show');
  $.ajax({
      url: form.attr('action'),
      data: form.serialize(),
      type: form.attr('method'),
      complete: function(response) {
          modal.find('.spinner').hide();
          var ct = response.getResponseHeader("content-type") || "";
          if (ct.indexOf('html') > -1) {
              modal.find('.modal-content').html(response.responseText);
          }
          if (ct.indexOf('json') > -1) {
              var json = $.parseJSON(response.responseText);
              if (json.redirectTo !== undefined) {
                  window.location.href = json.redirectTo;
              }
          }
      }
  })
});
